import { useState } from 'react';
import { useAsyncEffect } from 'ahooks';
import { FILE_ICONS } from './shared';
import DocumentCard from './DocumentCard';
import ImageCard from './ImageCard';
import { upload } from '@/common/upload/upload-ali';
import { upload as kbUpload } from '@/common/upload/upload-kb'
import { typeOf } from './file';
import { HelperCore } from '@/common/dependencies';
import { isEnableEnterpriseKbPage } from '@/components/kb-node-tree/utils'


function InputFileCard(props) {
  const { file, onClose, onError, supportKnowledge, isMulti } = props;

  const fileType = HelperCore.getFileNameExt(file?.name).toLowerCase();

  const [progress, setProgress] = useState(0);
  const [closeable, setCloseable] = useState(false);
  const [uploadResult, setUploadResult] = useState(false);

  const handleClose = (file) => {
    onClose?.(file);
  };

  const onButtonClick = ({ type, prompt }) => {
    props.onButtonClick?.(type, prompt, { ...uploadResult });
  };

  useAsyncEffect(async () => {
    setProgress(0);
    setCloseable(false);
    if (typeOf(file) !== 'file') {
      return;
    }
    const uploadFunc = isEnableEnterpriseKbPage() ?  kbUpload : upload
    uploadFunc(file, {
      progress: ({ progress }) => {
        setProgress(Math.round(progress * 100));
        setCloseable(true);
      },
      success: data => {
        setProgress(100);
        setCloseable(true);
        const { url, name, size, path = '', file_id = '' } = data;
        const uploadResult = {
          url,
          title: name ? name.slice(0, name.lastIndexOf('.')) : '',
          originalName: name,
          size,
          ext: fileType,
          local_path : path,
          file_id,
        };
        setUploadResult(uploadResult);
        props.onUploaded?.({ ...uploadResult });
      },
      fail: error => {
        onError?.(error);
      },
    });
  }, [file]);

  if (typeOf(file) !== 'file') {
    return null;
  }


  return FILE_ICONS[fileType] ? (
    <DocumentCard
      file={file}
      icon={FILE_ICONS[fileType]}
      progress={progress}
      closeable={closeable}
      onClose={handleClose}
      onButtonClick={onButtonClick}
    />
  ) : (
    <ImageCard
      file={file}
      progress={progress}
      closeable={closeable}
      onClose={handleClose}
      onButtonClick={onButtonClick}
      supportKnowledge={supportKnowledge}
      isMulti={isMulti}
    />
  );
}

export default InputFileCard;
